import React, { useState } from "react";
import { NavLink } from "react-router-dom";

import "./index.scss";

export default function Checkbox({
  id,
  label,
  linkText,
  link,
  onChange,
  defaultChecked = false,
  targetBlank = false,
}) {
  const [isChecked, setIsChecked] = useState(defaultChecked);

  const handleCheckboxChange = (event) => {
    const newValue = event.target.checked;
    setIsChecked(newValue);
    onChange(newValue);
  };

  return (
    <div className="checkbox">
      <div className="checkbox__group">
        <input
          type="checkbox"
          id={id}
          checked={isChecked}
          onChange={handleCheckboxChange}
        />
        <label htmlFor={id}></label>
      </div>
      <div className="checkbox__label">
        <label htmlFor={id} className="label">
          {label}
        </label>
        <NavLink
          to={link}
          target={targetBlank ? "_blank" : null}
          className="link"
        >
          {linkText}
        </NavLink>
      </div>
    </div>
  );
}
